var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.show)?_c('span',{staticClass:"sort-icon",class:{ rotate: _vm.rotate }},[_c('icon',{staticClass:"text-primary",attrs:{"icon":_vm.mdiMenuDown,"size":_vm.IconSize.XS}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }